export enum VendorSorterType {
  Rank = 0,
  Newest = 1,
  Random = 2,
  Rating = 3,
  DeliveryTime = 4,
}
